import { Component, OnInit, Input, Inject, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { SignaturePad } from 'ngx-signaturepad';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { MatRadioChange } from '@angular/material/radio';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { AddEmailForFormComponent } from '../addEmailForForm/addEmailForForm.component';
const { detect } = require('detect-browser');
const browser = detect();
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-openHtmlForm',
  templateUrl: './openHtmlForm.component.html',
  styleUrls: ['./openHtmlForm.component.scss'] 
})

export class OpenHTMLFormComponent implements OnInit {

  @Input() modulename: string;  
  @Input() entityID:number;
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any; 

  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  dropdownlist: any = [];
  OnlyPageOne = false;
  signOpt: string = 'draw';
  filenameForSign = "";
  defaultPage: number = 1;
  signName: string;
  SignButtonEnable: boolean = false;
  isSelectAll: boolean = false;
  fontSize = [
    { fontsize: 7 },
    { fontsize: 8 },
    { fontsize: 9 },
    { fontsize: 10 },
    { fontsize: 11 },
    { fontsize: 12 },
    { fontsize: 14 },
    { fontsize: 16 },
    { fontsize: 18 },
    { fontsize: 20 },
    { fontsize: 22 },
    { fontsize: 24 },
    { fontsize: 26 },
    { fontsize: 28 },
    { fontsize: 36 },
    { fontsize: 48 },
    { fontsize: 72 }
  ]
   family = [
  { font: 'Alex Brush' },
  { font: 'Allura' },
  { font: 'Architects Daughter' },
  { font: 'Caveat' },
  { font: 'Cedarville' },
  { font: 'Clicker Script' },
  { font: 'Cookie' },
  { font: 'Damion' },
  { font: 'Dancing Script' },
  { font: 'Devonshire' },
  { font: 'Dr Sugiyama' },
  { font: 'Engagement' },
  { font: 'Euphoria Script' },
  { font: 'Grand Hotel' },
  { font: 'Great Vibes' },
  { font: 'Herr Von Mueller hoff' },
  { font: 'Homemade Apple' },
  { font: 'Italianno' },
  { font: 'Kristi' },
  { font: 'League Script' },
  { font: 'Leckerli One' },
  { font: 'Mr Bedfort' },
  { font: 'Mr Dafoe' },
  { font: 'Mr DeHaviland' },
  { font: 'Niconne' },
  { font: 'Norican' },
  { font: 'Pacifico' },
  { font: 'Parisienne' },
  { font: 'Petit Formal Script' },
  { font: 'Pinyon Script' },
  { font: 'Qwigley' },
  { font: 'Rochester' },
  { font: 'Romanesco' },
  { font: 'Sacramento' },
  { font: 'Satisfy' },
  { font: 'Segoe Print' },
  { font: 'Segoe Script' },
  { font: 'Sofia' },
  { font: 'Stalemate' },
  { font: 'Yellowtail' }
];
  fontfamilys = [
    { font: 'Arial' },
    { font: 'Calibri' },
    { font: 'Tahoma' },
    { font: 'Verdana' },
  ]
  currentSign = {
    data: '',
    id: ''
  }
  selected = 'option1';
  //signaturePadOptions:any;
  signaturePadOptions: any = {
    'minWidth': 2,
    'canvasWidth': 822,
    'canvasHeight': 150,
    'penColor': "blue"
  };
  ipAddress: string;
  browsername: any;
  device: any;
  token: any;
  params: string;
  formID: number=0;
  userID: any;
  CoreName: any;
  ContactName: any;
  CompanyName: any;
  innerWidth: number;
  innerHeight: number;
  Ssignature: boolean;
  Module: any;
  ResponseHolderDetails: any;
  dataJson: any;
  currentFormName: any;
  selectedFolderID: any;
  Imageurl: string | ArrayBuffer;
  penColor: string = '';
  geolocationPosition: any;
  LocationWithFields: any = [];
  SreadOnly: boolean = false;
  isRequired: boolean = false;
  readonly: boolean = false;
  Srequired: boolean;
  acceptOrdeclineText: string = 'Approve';
  controlAlignArray: any = [];
  currentPageName: string = "Page1"
  currentPage = 1;
  currentStep: number = 1;
  buttonText: string = 'Button';
  buttonURL: string = "";
  fillListcontrolId: any;
  participantArray: any = [];
  projectDocuments: any = [];
  projectDocumentpageImages: any = [];
  ParticipantJsonList: any = [];
  selectedDocumentId: any;
  SubmitNextButtonDisabled: boolean = false;
  changesForUndo: any = [];
  changesForRedo: any = [];
  offsetWidth: number = 0;
  offsetHeight: number = 0;
  showAllRequiredControls: boolean = false;
  indexExpanded: number;
  ControlId: string = "";
  ControlData: any;
  InitailButtonEnable: boolean;
  brushColor: any;
  text: string = "";
  ShowHeader: boolean = false;
  ShowFooter: boolean = false;
  SubmitBy: string = '';
  TaskID: any = 0;
  HeaderFooter: any = [] = [];
  placeholderID: number = 0;
  transactionID: number = 0;
  type: number = 0;
  headerText: any;
  fontColor: any;
  fontHeaderSize: any;
  fontFamily: any;
  ShowFillForm: boolean = false;
  verifiedEmail: string
 
  participantEmailId: string
  safeSrcVideo: SafeResourceUrl;
  dialogRef1: any;
  tableFieldJson: any = [];
  isFormTypeCheckIn: boolean = false;
  isCheckIn: boolean = false;
  htmlFormDatatID: number = 0;
  selected3cType: boolean=false;
  backgroundColorForm:string="";
  LoggedInEmailId: string = "";
  formName:string="";

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<OpenHTMLFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService,private loaderService: LoaderService, 
    private http: HttpClient,private httpbackend: HttpBackend,private cdr: ChangeDetectorRef,
    private _sanitizer: DomSanitizer,private router: Router, private formsService: FormsService,) {  
      var skipInterceptor = new HttpClient(httpbackend);
       skipInterceptor.get<{ ip: string }>('https://api.ipify.org?format=json').subscribe(data => {
      this.ipAddress = data.ip;
    });
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    this.LoggedInEmailId = sessionStorage.getItem('email');
    if(encryptedtoken!=null){
    
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    }     
  }  
  
  ngOnInit(): void {     
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.Ssignature = true;
    this.signaturePadOptions = {
      'minWidth': 2,
      'canvasWidth': 822,
      'canvasHeight': 150,
      'penColor': "blue"
    };

    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
    }
    this.getQueryParameter();     
    this.cdr.detectChanges();   
  }     
 

  closePopup() {   
    this.dialog.closeAll();
  }

  ngAfterViewInit() {
    if (this.signaturePad != undefined) {
      this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }

    this.verifiedEmail = this.LoggedInEmailId;//sessionStorage.getItem('userEmailForCode');
    this.participantEmailId = this.verifiedEmail;
    this.SubmitBy = this.verifiedEmail;  
  }

  authenticationEmail: string;
  showName:any=false;
  name: string;
  isEmailVerified = false;
  otpCode: number
  verifyToken: number=0;
   
  ngDoCheck() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }
  
  isPopupOpenForAddEmail: boolean = false;
  Arr = Array;
  urlParameter:any=[]=[];

  getQueryParameter() {
      this.data;             
      this.formID = this.data.htmlData.formID;
      this.organizationId = this.organizationId;
      this.databaseId = this.databaseId;
      this.userID =  this.currentUser.UID;
      this.myOfficeID = this.myOfficeID;
      this.formName = this.data.htmlData.formName;
      this.SubmitBy = "";
      this.type = this.data.type;
      this.placeholderID = 0;
      this.transactionID = this.data.transactionID;
      this.TaskID = 0;

      this.GetHtmlForms(this.formID); 
 
  }


  getStepLenth() {
    return this.currentStep < this.controlAlignArray.filter((x:any) => x.type !== "Header" && x.type !== "Footer").length;
  }

  cancel() {
    this.dialog.closeAll();
    //this.router.navigate(['/request/htmlthanks'], { state: { isCancel: true } });
  }

  ChangeStep(check) {
    if (check == 1) {
      this.currentStep--;
    } else {
      this.currentStep++;
    }
    this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
    this.currentPage = this.currentStep
  }

  isMatch:boolean=false;
  redirectUrl:string="";
  isDisableAutoFill:boolean=false;
  isUrlParameterConfigured:boolean=false;
  
  GetHtmlForms(HtmlId: any) {
     this.urlParameter=[];      
    var ReqModel = {
      formID: Number(HtmlId),
      case:0,// 0-internal, 1-external,
      urlParameters:this.urlParameter,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.spinner = true;
    this.formsService.getHtmlForm(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        this.isUrlParameterConfigured=response.data.isUrlParameterConfigured;
        this.backgroundColorForm = response.data.formBgColor;        

        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.selected3cType=this.ResponseHolderDetails.data.selected3cType ==1 ? true : false;
          if(this.selected3cType==true) {
              this.showName=true;
              this.showEmail=true;
              this.showMobile=true;
            }
          this.controlAlignArray = JSON.parse(this.ResponseHolderDetails.data.formJson);
          this.getTableFieldJson();
          this.OnlyPageOne = this.controlAlignArray.length == 1
          this.controlAlignArray.forEach(f => {
            f.fields.forEach(ef => {
              if (ef.fieldJson.selectedValue != null && ef.fieldJson.selectedValue != undefined && ef.fieldJson.fieldTypeName == 'HtmlEditor') {
                ef.fieldJson.selectedValue = this._sanitizer.bypassSecurityTrustHtml(ef.fieldJson.selectedValue);
              }
            });

          });
          this.dataJson = JSON.parse(this.ResponseHolderDetails.data.dataJson);
          this.HeaderFooter = JSON.parse(this.ResponseHolderDetails.data.headerFooterJson);
          if (this.HeaderFooter !== undefined && this.HeaderFooter !== null && this.HeaderFooter.length > 0 && this.HeaderFooter.find(x => x.type == 'Header') !== undefined) {
            this.headerText = this.HeaderFooter.find(x => x.type == 'Header').text;
            this.fontColor = this.HeaderFooter.find(x => x.type == 'Header').color;
            //this.fontHeaderSize=this.HeaderFooter.find(x => x.type == 'Header').fontSize;
            //this.fontFamily=this.HeaderFooter.find(x => x.type == 'Header').fontFamily;
          }
          this.currentFormName = this.ResponseHolderDetails.data.formName;
          this.selectedFolderID = this.ResponseHolderDetails.data.formFolderID;
          if (this.controlAlignArray == null || this.controlAlignArray == undefined) {
            this.controlAlignArray = [];
          }
          if (this.dataJson == null || this.dataJson == undefined) {
            this.dataJson = [];
          }
          var checkHeader = [];
          var checkFooter = [];
          var checkdata = [];
          checkdata = JSON.parse(this.ResponseHolderDetails.data.headerFooterJson);
          if (checkdata != null && checkdata != undefined) {
            checkHeader = checkdata.filter((x:any) => x.type == "Header");
            checkFooter = checkdata.filter((x:any) => x.type == "Footer");
          }

          if (checkHeader.length > 0) {
            this.ShowHeader = true;
          }
          if (checkFooter.length > 0) {
            this.ShowFooter = true;
          }

          //  Core=1, Contact=2, Company=3
          if (Number(this.type) == 1) {
            var checkAutoFillforCore = [];
            checkAutoFillforCore = this.dataJson.filter((x:any) => x.folderID > 0 && x.folderName == "core");
            if (checkAutoFillforCore.length > 0) {
              this.ShowFillForm = true;
            } else {
              this.ShowFillForm = false;
            }
          }

          if (Number(this.type) == 2) {
            var checkAutoFillforContact = [];
            checkAutoFillforContact = this.dataJson.filter((x:any) => x.folderID > 0 && x.folderName == "contact");
            if (checkAutoFillforContact.length > 0) {
              this.ShowFillForm = true;
            } else {
              this.ShowFillForm = false;
            }
          }

          if (Number(this.type) == 3) {
            this.ShowFillForm = false;
          }

          this.loaderService.hide();
          this.spinner = false;
        } else {
          this.loaderService.hide();
          this.spinner = false;
        }
      } else {
        this.loaderService.hide();
        this.spinner = false;
      }
    });
  }

  getTableFieldJson() {
    this.tableFieldJson = [];
    this.controlAlignArray.forEach(page => {
      page.fields.filter(m => m.id.includes('Table-')).forEach(field => {
        field.fieldJson.fillList.forEach(element => {
          this.tableFieldJson.push({
            val: element.val,
            id: element.id
          });
        });
      });
    })
  }

  getYoutubeEmbedUrl(link) {
    let ytUrl = 'https://www.youtube.com/embed/';
    const equalIndex = link.indexOf('=');
    const videoCode = equalIndex != -1 ? link.substring(equalIndex + 1) : '';
    ytUrl += videoCode;
    return ytUrl;
  }

  openVideoLink(link, templateRef: TemplateRef<any>) {
    this.safeSrcVideo = "";
    if (link != null && link != "" && link != undefined) {
      const isYoutube = link.toLowerCase().includes('youtube');
      if (link.substring(0, 4) == 'http' && isYoutube) {
        const srcVideo = isYoutube ? !link.includes('embed') ? this.getYoutubeEmbedUrl(link) : link : link;
        this.safeSrcVideo = this._sanitizer.bypassSecurityTrustResourceUrl(srcVideo);
        this.dialogRef = this.dialog.open(templateRef, {
          panelClass: 'custom-modalbox'
        });
        return;
      }
      if (link.substring(0, 4) == 'http') {
        window.open(link, '_blank');
      } else {
        window.open('https://' + link, '_blank');
      }
    } else {
      this.toastr.warning('No URL or link is provided to open.', '', {
        timeOut: 3000,
      });
    }
  }

  closeVideo() {
    this.dialogRef.close();
    this.safeSrcVideo = "";
  }

  SubmitHTMLForm(HtmlId: any) {  
    this.SubmitBy= this.LoggedInEmailId;
    var ReqModel = {
      formID: Number(HtmlId),
      jsonData: JSON.stringify(this.dataJson),
      filledJsonData:JSON.stringify(this.controlAlignArray),
      submitBy: this.SubmitBy,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      placeholderID: Number(this.placeholderID),
      transactionID: Number(this.transactionID),
      type: Number(this.type),//  Core=1, Contact=2, Company=3
      TaskID: 0,
      checkIn:this.isCheckIn,
      HtmlFormDatatID:this.htmlFormDatatID,
      Name:this.name,
      Email:this.authenticationEmail,
      Phone:this.authenticationMobile
    };
    this.loaderService.show();
    this.spinner = true;
    this.formsService.SubmitHTMLForm(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          if (this.ResponseHolderDetails.data == true) {
            this.toastr.success("Form submitted successfully.")
            this.dialog.closeAll();          
          }
          this.loaderService.hide();
          this.spinner = false;
        } else {
          this.loaderService.hide();
          this.spinner = false;
        }
      } else {
        this.loaderService.hide();
        this.spinner = false;
      }
    });
  }



  onChanges(value: any, step: any, item: any) {
    this.text = value;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = value == undefined ? '' : value;
    // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == data.id).selectedValue = value == undefined ? '' : value;

    this.dataJson.find(x => x.id == item.id).value = value == undefined ? '' : value;
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  selectRating(drp, item, step) {
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = drp.val == undefined ? '' : drp.val;
    let changeJsonArray = this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList;
    changeJsonArray.forEach(element => {
      element.active = false;
    });
    changeJsonArray.forEach(element => {

      if (element.id <= drp.id) {
        element.active = true;
      }
    });
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList = changeJsonArray;
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList.find(m=>m.id==drp.id).active=true;
    this.dataJson.find(x => x.id == item.id).value = drp.id;
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  selectFeedback(drp, item, step) {
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = drp.val == undefined ? '' : drp.val;
    let changeJsonArray = this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList;
    changeJsonArray.forEach(element => {
      element.active = false;
    });
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList = changeJsonArray;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList.find(m => m.id == drp.id).active = true;
    this.dataJson.find(x => x.id == item.id).value = drp.val;
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }


  McqRadioChange(e: any, data: any, item: any) {
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == item.id).fieldJson.radioSelectedValue = e.value == undefined ? '' : e.value;
      //this.textalign = textalign;
    }
    this.dataJson.find(x => x.id == item.id).value = e.value;
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  onChangesDate(value: any, step: any, item: any) {
    this.text = value;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = value == undefined ? '' : value;
    // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == data.id).selectedValue = value == undefined ? '' : value;

    var date = new Date(value);
    var newtdate = "";
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    newtdate = mm + '/' + dd + '/' + yyyy;
    this.dataJson.find(x => x.id == item.id).value = newtdate;//value == undefined ? '' : value.tostring();  
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  FindCurrentStep(controlAlignArray) {
    return controlAlignArray.filter((x:any) => x.step == this.currentStep);
  }

  GoToPage(step: number) {
    this.currentPage = step;
    this.currentStep = step;
    this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
  }

  onChangeText(value: any) {
    var data = this.ControlData;
    this.ControlId;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.selectedValue = value == undefined ? '' : value;
    }
    if (this.dataJson.find(x => x.id == this.ControlId)) {
      this.dataJson.find(x => x.id == this.ControlId).value = value == undefined ? '' : value;
    }
  }

  onChangeTextButton(value: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.buttonName = value == undefined ? '' : value;
      //this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id ==  data.id).buttonName = value == undefined ? '' : value;
    }
  }

  onChangeUrlButton(value: any) {
    var data = this.ControlData;
    var url = this.addAnchorsToText(value);
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.buttonURL = url == undefined ? '' : url;
      // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id ==  data.id).buttonURL = url == undefined ? '' : url;
    }
  }

  addAnchorsToText(text) {
    // https://www.regextester.com/94502
    const regexp = /((?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+%,;=.]+)/igm;
    const map = {};
    return text.replace(regexp, (_, match, __, pos) => {
      // This map helps us to keep a count of the duplicate matches.
      if (map[match] !== undefined) map[match]++;
      else map[match] = 0;

      // These next few lines handle duplicates. We want to handle cases like this: 
      // <a href="myurl.com">foo</a> bar baz myurl.com.
      let testString = text.replace(new RegExp(escapeRegExp(match), 'ig'), '$');
      let newPos = pos - map[match] * (match.length - 1);
      testString = this.insertIntoString(testString, newPos, match);

      // Detect if the url was found here -> <a href="#here#">
      const hrefRegex = new RegExp(`<a[^>]*href="${escapeRegExp(match)}"[^>]*>[^<]*<\/a>`, 'ig');
      const isHref = hrefRegex.test(testString);

      // Detect if the url was found here -> <a href="...">#here#</a>
      const anchoredRegex = new RegExp(`<a[^>]*>[^<]*${escapeRegExp(match)}[^<]*<\/a>`, 'ig');
      const isAnchored = anchoredRegex.test(testString);


      // If the url is found in href or anchor, then do nothing with it, it needs no further treatment.
      if (isAnchored || isHref) return match;
      const hasProtocol = /^http[s]?:\/\/.*$/igm.test(match);
      //var data = "http://'}${match}";
      return `${hasProtocol ? '' : 'http://'}${match}`;
    });
    function escapeRegExp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
  }

  insertIntoString(str: string, pos: number, fragment: string) {
    return str.slice(0, pos) + fragment + str.slice(pos + 1, str.length);
  }

  setDdlValue(e: any, data: any, field) {
    this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.selectedValue = e.target.value;
    this.dataJson.find(x => x.id == field.id).value = e.target.value;
  }

  specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  regex: RegExp = new RegExp(/^\d*\.?\d{0,10}$/g);

  numberOnly(event): boolean {
    let value = event.target.value;
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = value;
    const position = event.target.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

   fetchLocation(data, id) {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        position => {
          this.geolocationPosition = position;
          if (this.controlAlignArray.find(x => x.step == data.step)) {
            this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.Lat = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.latitude : '';
            this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.Long = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.longitude : '';
          }
          if (this.dataJson.find(x => x.id == id)) {
            this.dataJson.find(x => x.id == id).value = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.latitude + "," + this.geolocationPosition.coords.longitude : '';
            this.dataJson.find(x => x.id == id).ctrlType = 'Location';
          }
        },
        error => {
          switch (error.code) {
            case 1:
              break;
            case 2:
              break;
            case 3:
              break;
          }
        }
      );
    };
  }

  ifChkChecked(id, data, childCtrlId) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      let selectedValue = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.chkSelectedValues;
      return selectedValue.includes(childCtrlId);
    }
    return false;
  }

  OpenlButtonLink(data: any, id, event: any) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      var FieldsDetails = this.controlAlignArray.find(x => x.step == data.step);
      var getData = FieldsDetails.fields.find(x => x.id === id).fieldJson;
      if (getData != null && getData != undefined) {

        this.buttonText = getData.buttonName;
        this.buttonURL = getData.buttonURL;

        if (this.buttonURL != "" && this.buttonURL != undefined && this.buttonURL != '') {
          const url = this.buttonURL;
          window.open(url, '_blank');
        }
      }
    }
  }


  OnChangeCheckBox($event: any, chk: any, field: any, data: any, childCtrlID: any) {
    if ($event.target.checked) {
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.push(childCtrlID);
      this.dataJson.find(x => x.id == field.id).value = true;
    } else {
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.pop(childCtrlID);
      this.dataJson.find(x => x.id == field.id).value = false;
    }
    // if(this.dataJson.find(x => x.id == field.id)){
    //   let slectedValues=this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues;

    //   if(slectedValues.length>0)
    //    this.dataJson.find(x => x.id == field.id).value = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.fillList.filter(n=>slectedValues.includes(n.id)).map(a => a.val).join(',');
    //   else
    //    this.dataJson.find(x => x.id == field.id).value='';
    // }
  }

  // OnChangeCheckBox($event: any, chk: any, field: any, data: any,childCtrlID:any) { 
  //   if ($event.target.checked) {       
  //     this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.push(childCtrlID);
  //   }
  //   else
  //   {
  //     this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.pop(childCtrlID);
  //   } 
  //   if(this.dataJson.find(x => x.id == field.id)){
  //     let slectedValues=this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues;

  //     if(slectedValues.length>0)
  //      this.dataJson.find(x => x.id == field.id).value = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.fillList.filter(n=>slectedValues.includes(n.id)).map(a => a.val).join(',');
  //     else
  //      this.dataJson.find(x => x.id == field.id).value='';
  //   }
  // }

  getTableBGValue(data: any, tblId: any, row: any, col: any) {
    let bgColor = '';
    if (this.tableFieldJson.length > 0) {
      const txtId = tblId + 'txt-' + row + '' + col;
      const obj = this.tableFieldJson.filter(m => m.id == txtId);
      if (obj) {
        const txtVal = obj[0].val;
        bgColor = txtVal.length > 0 ? '#D5DBDB' : '';
      }
    }
    return bgColor;
  }

  isTableCallDisable(data: any, tblId: any, row: any, col: any) {
    let cellState = false;
    if (this.tableFieldJson.length > 0) {
      const txtId = tblId + 'txt-' + row + '' + col;
      const obj = this.tableFieldJson.filter(m => m.id == txtId);
      if (obj) {
        const txtVal = obj[0].val;
        cellState = txtVal.length > 0 ? true : false;
      }
    }
    return cellState;
  }

  getColumnValue(data: any, tblId: any, row: any, col: any) {
    let id = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == tblId).fieldJson.id + 'txt-' + row + col;
    let val = '';
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      val = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == tblId).fieldJson.fillList.find(m => m.id == id).val;
    }
    return val

    // let id = 'txt-' + row + col;
    // let val = '';
    // if (this.controlAlignArray.find(x => x.id == data.id)) {
    //   val = this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == tblId).fillList.find(m => m.id == id).val;
    // }
    // return val;
  }

  onTableChange(e: any, data: any, id) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.fillList.find(m => m.id == e.target.id).val = e.target.value == undefined ? '' : e.target.value;
    }
    if (this.dataJson.find(x => x.id == e.target.id)) {
      this.dataJson.find(x => x.id == e.target.id).value = e.target.value == undefined ? '' : e.target.value;
    }
  }

  onSelectFile(event, data: any, id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];

        var base64String = reader.result;

        var FileObj = [];
        FileObj.push({
          FullPath: FullPath,
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Base64String: base64String
        });

        if (this.controlAlignArray.find(x => x.step == data.step)) {
          //this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.Lat = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.latitude : '';
          this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.FileData = FileObj
        }

        if (this.dataJson.find(x => x.id == id)) {
          this.dataJson.find(x => x.id == id).FileName = documentName;
          this.dataJson.find(x => x.id == id).FileExtention = documenttype;
          this.dataJson.find(x => x.id == id).value = base64String;
          this.dataJson.find(x => x.id == id).type = 'image';
          this.dataJson.find(x => x.id == id).ctrlType = 'File';
        }
      }
    }
  }
 

  OpenSignPopup(templateRef: TemplateRef<any>, data: any, item: any, event: any) {
    this.InitialsID = 0;
    this.signatureID = 0;
    this.signatureData = null;
    this.initialData = null;
    this.getAllSignatures = [];
    this.getAllInitials = [];
    if (item.fieldJson.fieldName == "Signature") {
      this.getAllSignature(templateRef, data, item);
    }
    if (item.fieldJson.fieldName == "Initials") {
      this.getAllInitial(templateRef, data, item);
    }

    this.ControlData = data;
    this.ControlId = item.id;
    this.SignButtonEnable = false;
    this.InitailButtonEnable = false;
    if (this.ControlId == undefined) {
      this.ControlId = item;
    }
    this.Ssignature = true;
    this.currentSign.data = data;
    this.currentSign.id = item.id;
    this.filenameForSign = "";
    this.signName = "";
    this.selected = ''
    this.signOpt = 'draw';


    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
        if (element.id != item.id)
          element.ShowtoolDetail = false;
        else
          element.ShowtoolDetail = true;
      });

      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter((x:any) => x.id === item.id);
      if (getData.length > 0) {
        this.ControlData = FieldsDetails;
        this.ControlId = item.id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        if (getData[0].brushColor != undefined)
          this.brushColor = getData[0].brushColor;
      }
    }


  }

  imgDrawStart() {
    if (this.brushColor != "")
      this.signaturePadOptions.penColor = "RGB(" + this.hexToRGBA(this.brushColor, 1) + ")";
    else {
      this.brushColor = "#000000";
      this.signaturePadOptions.penColor = "RGB(" + this.hexToRGBA(this.brushColor, 1) + ")";
    }
  }

  hexToRGBA(hex, opacity) {
    if (hex == undefined || (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')) == null || (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')) == undefined) {
      return;
    }
    return (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')).map(function (l) { return parseInt(hex.length % 2 ? l + l : l, 16) }).concat(isFinite(opacity) ? opacity : 1).join(',');
  }

  onSelectImage(event, data: any, id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];

        var base64String = reader.result;

        var ImageObj = [];
        ImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        if (this.controlAlignArray.find(x => x.step == data.step)) {
          this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.ImageData = ImageObj;
        }

        if (this.dataJson.find(x => x.id == id)) {
          this.dataJson.find(x => x.id == id).value = base64String;
          this.dataJson.find(x => x.id == id).type = 'image';
          this.dataJson.find(x => x.id == id).ctrlType = 'Image';
        }
      }
    }
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
  }

  signatureBase64: string;
  signOrInitialImageObj: any[];

  signOrInitialTextChanges(e: any) {
    if (this.signName !== '' && this.signName !== undefined) {
      this.SignButtonEnable = true;
      this.InitailButtonEnable = true;
      this.signatureBase64 = '';
      this.signOrInitialImageObj = [];
    } else {
      this.SignButtonEnable = false;
      this.InitailButtonEnable = false;
    }
  }

  onSelectSignImage(event, data: any, id: any) {
    data = this.currentSign.data;
    id = this.currentSign.id;
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      this.SignButtonEnable = true;
      this.InitailButtonEnable = true;
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;

        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
        this.filenameForSign = documentName;
        var base64String = reader.result;

        this.signOrInitialImageObj = [];
        this.signOrInitialImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        this.signatureBase64 = '';
        this.signName = '';

      }
    }
  }

  radioChangeSign() {
    this.SignButtonEnable = false;
  }

  radioChangeInitails() {
    this.InitailButtonEnable = false;
  }

  signInitialFontFamily: any;

  setSignInitialFontFamilyChange(e: any) {
    this.signInitialFontFamily = e;
  }

  DrawButtonEnable: boolean = false;
  reasonToDecline: string = "";
  declineButtonShow: boolean = false;
  savebuttonshow: boolean = true;
  spinner: boolean = false;
  activeNode: string = "";

  Done() {
    this.SignButtonEnable = false;
    this.DrawButtonEnable = false;
    this.reasonToDecline = "";
    this.declineButtonShow = false;
    // this.SubmitBy="";
    this.dialog.closeAll();
    this.savebuttonshow = true;
    this.spinner = false;
  }

  close() {
    this.SignButtonEnable = false;
    this.DrawButtonEnable = false;
    this.reasonToDecline = "";
    this.declineButtonShow = false;  
    this.dialogueRef.close();  
    this.savebuttonshow = true;
    this.spinner = false;
  }
 
  clearSignature() {
    this.SignButtonEnable = false;
    if (this.signaturePad != undefined) {
      this.signaturePad.clear();
    }
    let canvas = document.getElementsByTagName("canvas")[0];
    if (canvas != undefined) {
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.beginPath();
    }
  }

  drawComplete() {
    this.SignButtonEnable = true;
    this.DrawButtonEnable = true;
    this.InitailButtonEnable = true;
    // will be notified of szimek/signature_pad's onEnd event    
    //let canvas = document.getElementsByTagName("canvas")[0]; 
    // this.signatureBase64=canvas.toDataURL();
  }

  

  addSignature() {
    if (this.signatureID > 0) {
      this.addSignatureAdopt();
    } else {     
      let data: any = this.ControlData;
      let canvas = document.getElementsByTagName("canvas")[0];
      if (canvas != undefined) {
        this.signatureBase64 = canvas.toDataURL();
        this.signName = "";
        this.signOrInitialImageObj = [];
      }
      if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureBase64 = this.signatureBase64;
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureText = this.signName;
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signInitialFontFamily = this.signInitialFontFamily;
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.ImageData = this.signOrInitialImageObj;
      }

      if (this.dataJson.find(x => x.id == this.ControlId)) {
        if (this.signatureBase64 != '') {
          this.dataJson.find(x => x.id == this.ControlId).value = this.signatureBase64;
          this.dataJson.find(x => x.id == this.ControlId).type = 'image';
        }
        else if (this.signName != '') {
          this.dataJson.find(x => x.id == this.ControlId).value = this.signName;
          this.dataJson.find(x => x.id == this.ControlId).type = 'text';
          this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
        }
        else {
          this.dataJson.find(x => x.id == this.ControlId).value = this.signOrInitialImageObj[0].Imageurl;
          this.dataJson.find(x => x.id == this.ControlId).type = 'image';
          this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = '';
        }
      }


      var signatureBase;
      var isDefault;
      var type;
      var obj;

      if (this.signatureBase64 != "") {
        obj = {
          type: "Draw",
          signatureBase64: this.signatureBase64,
        }
      }
      if (this.signOrInitialImageObj.length > 0) {
        obj = {
          type: "Upload",
          ImageData: this.signOrInitialImageObj,
        }
      }
      if (this.signName != "") {
        obj = {
          type: "Type In",
          signatureText: this.signName,
          signInitialFontFamily: this.signInitialFontFamily
        }
      }


      var rqModel = {
        signature: JSON.stringify(obj),
        email: this.participantEmailId,
        isDefault: true
      }
      // return;
      this.formsService.addSignature(rqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {

          }
        }
      });


    }
    this.dialogueRef.close();
  }



  // =============== For AutoFill =========================//

  autoFill: boolean = false;
  cityOption: string[] = [];
  zipOption: any[];
  stateList: any[];
  cityValue: any;
  stateValue: any;
  zipValue: any;


  particiantJsonListAutoFillCore: any = [];
  particiantJsonListAutoFillContact: any = [];
  fieldFolders: any = [] = [];
  openPanel: number = 0;
  groupRelationParticipantId: string = "";
  autofillvalues: any = [];

  onAutoFillChanged(event) {
    this.autoFill = true;
    if (this.type == 1) {
      this.getFieldValuesForAutoFillCore();
    }
    if (this.type == 2) {
      this.getFieldValuesForAutoFillContact();
    }
  }


  getFieldValuesForAutoFillCore() {
    let coretFolder: any = [];
    coretFolder.push(this.fieldFolders.find(n => n.name == 'Core'));
    let reqModel = {
      databaseID: this.databaseId,
      OrganizationID: this.organizationId,
      folderID: coretFolder[0].folderID,
      officeID: this.myOfficeID,
      CoreID: this.transactionID,//this.decryptedToken.CoreID,
      IsTabularForm: false,
    };
    if ((this.groupRelationParticipantId == '0' || this.groupRelationParticipantId == undefined) && (reqModel.CoreID == 0 || reqModel.CoreID == undefined))
      return;
    this.formsService.getFieldValuesForAutoFillCore(reqModel).subscribe(response => {
      this.autofillvalues = response.data;
      this.particiantJsonListAutoFillCore.map((entry) => {
        entry.fields.filter((x:any) => x.folderID == coretFolder[0].folderID).forEach((field) => {
          if (field.fieldJson.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '') {
            field.fieldJson.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.fieldJson.chkSelectedValues.length == 0)
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.fieldJson.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }

          if (field.fieldJson.fieldTypeName === "MultiSelect") {
            if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.length > 0)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
            else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue?.split(',');
          }
          else if (field.fieldJson.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 0 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 3 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 2 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 4 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
            field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
        });
      });

      this.controlAlignArray.map((entry) => {
        entry.fields.filter((x:any) => x.folderID == coretFolder[0].folderID).forEach((field) => {
          if (field.fieldJson.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '') {
            field.fieldJson.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.fieldJson.chkSelectedValues.length == 0)
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.fieldJson.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }

          if (field.fieldJson.fieldTypeName === "MultiSelect") {
            if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.length > 0)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
            else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue?.split(',');
          }
          else if (field.fieldJson.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 0 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 3 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 2 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 4 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
            field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
          this.dataJson.find(x => x.id == field.id && x.folderID == field.fieldJson.folderID).value = field.fieldJson.selectedValue;
        });
      });


      // auto fill other jsons and save
      this.controlAlignArray.forEach(ml => {
        let jsonelement: any;
        if (this.selectedDocumentId !== ml.documentID) {
          jsonelement = JSON.parse(ml.controlAlignArray);
          jsonelement.map((entry) => {
            entry.fields.filter((x:any) => x.folderID == coretFolder[0].folderID).forEach((field) => {
              if (field.fieldJson.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '') {
                field.fieldJson.defaultValue.split(',').forEach((value, key) => {
                  if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue != '' &&
                    this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                    if (field.fieldJson.chkSelectedValues.length == 0)
                      field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                    else if (!field.fieldJson.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                      field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                    }
                  }
                })
              }

              if (field.fieldJson.fieldTypeName === "MultiSelect") {
                if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.length > 0)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
                else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue?.split(',');
              }
              else if (field.fieldJson.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 0 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldJson.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 3 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldJson.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 2 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldJson.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 4 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
              }
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
                field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
              this.dataJson.find(x => x.id == field.id && x.folderID == field.fieldJson.folderID).value = field.fieldJson.selectedValue;
            });
          });

          ml.controlAlignArray = JSON.stringify(jsonelement);
        }
      });
    });
  }


  getFieldValuesForAutoFillContact() {
    let contactFolder: any = []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n => n.name == 'Contact'));
    let reqModel = {
      databaseID: this.databaseId,
      OrganizationID: this.organizationId,
      folderID: contactFolder[0].folderID,
      officeID: this.myOfficeID,
      ContactID: this.transactionID,//this.decryptedToken.CoreID,
      IsTabularForm: false,
    };
    if ((this.groupRelationParticipantId == '0' || this.groupRelationParticipantId == undefined) && (reqModel.ContactID == 0 || reqModel.ContactID == undefined))
      return;
    this.formsService.getFieldValuesForAutoFill(reqModel).subscribe(response => {
      this.autofillvalues = response.data;
      this.particiantJsonListAutoFillContact.map((entry) => {
        entry.fields.filter((x:any) => x.folderID == contactFolder[0].folderID).forEach((field) => {
          if (field.fieldJson.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '') {
            field.fieldJson.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.fieldJson.chkSelectedValues.length == 0)
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.fieldJson.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }

          if (field.fieldJson.fieldTypeName === "MultiSelect") {
            if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.length > 0)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
            else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue?.split(',');
          }
          else if (field.fieldJson.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 0 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 3 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 2 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 4 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
            field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
        });
      });

      this.controlAlignArray.map((entry) => {
        entry.fields.filter((x:any) => x.folderID == contactFolder[0].folderID).forEach((field) => {
          if (field.fieldJson.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '') {
            field.fieldJson.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.fieldJson.chkSelectedValues.length == 0)
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.fieldJson.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }

          if (field.fieldJson.fieldTypeName === "MultiSelect") {
            if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.length > 0)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
            else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue?.split(',');
          }
          else if (field.fieldJson.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 0 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 3 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 2 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldJson.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.fieldJson.childFieldType === 4 || field.fieldJson.childFieldType == undefined)
              field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
            field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
          this.dataJson.find(x => x.id == field.id && x.folderID == field.fieldJson.folderID).value = field.fieldJson.selectedValue;
        });
      });


      // auto fill other jsons and save
      this.controlAlignArray.forEach(ml => {
        let jsonelement: any;
        if (this.selectedDocumentId !== ml.documentID) {
          jsonelement = JSON.parse(ml.controlAlignArray);
          jsonelement.map((entry) => {
            entry.fields.filter((x:any) => x.folderID == contactFolder[0].folderID).forEach((field) => {
              if (field.fieldJson.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '') {
                field.fieldJson.defaultValue.split(',').forEach((value, key) => {
                  if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue != '' &&
                    this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                    if (field.fieldJson.chkSelectedValues.length == 0)
                      field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                    else if (!field.fieldJson.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                      field.fieldJson.chkSelectedValues.push("ctrl-" + (key));
                    }
                  }
                })
              }

              if (field.fieldJson.fieldTypeName === "MultiSelect") {
                if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue.length > 0)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
                else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue?.split(',');
              }
              else if (field.fieldJson.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 0 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldJson.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 3 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldJson.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 2 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldJson.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.fieldJson.childFieldType === 4 || field.fieldJson.childFieldType == undefined)
                  field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
              }
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID)?.fieldValue !== '')
                field.fieldJson.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldJson.fieldID && d.folderID == field.fieldJson.folderID)?.fieldValue;
              this.dataJson.find(x => x.id == field.id && x.folderID == field.fieldJson.folderID).value = field.fieldJson.selectedValue;
            });
          });

          ml.controlAlignArray = JSON.stringify(jsonelement);
        }
      });
    });
  }

  cancelFillForm() {
    this.fieldFolders = [];
    let coretFolder: any = [];
    let contactFolder: any = [];

    var objcore = {
      folderID: 17,
      name: "Core"
    }
    var objcontact = {
      folderID: 20,
      name: "Contact"
    }
    this.fieldFolders.push(objcore);
    this.fieldFolders.push(objcontact);

    coretFolder.push(this.fieldFolders.find(n => n.name == 'Core'));
    contactFolder.push(this.fieldFolders.find(n => n.name == 'Contact'));

    if (this.controlAlignArray.length > 0) {
      for (var i = 0, len = this.controlAlignArray.length; i < len; ++i) {
        var checkdataAutofillfields = [];
        checkdataAutofillfields = this.controlAlignArray[i].fields;
        if (checkdataAutofillfields.length > 0) {
          for (var i1 = 0, len1 = checkdataAutofillfields.length; i1 < len1; ++i1) {
            if (checkdataAutofillfields[i1].folderID == coretFolder[0].folderID) {
              this.controlAlignArray.find(x => x.step == this.controlAlignArray[i].step).fields.find(m => m.id == checkdataAutofillfields[i1].id).fieldJson.selectedValue = "";
              this.dataJson.find(x => x.id == checkdataAutofillfields[i1].id && x.folderID == checkdataAutofillfields[i1].folderID).value = "";
            }
          }
        }
      }
    }
    this.dialog.closeAll();
  }


  fillForms(templateRef: TemplateRef<any>) {

    this.particiantJsonListAutoFillCore = [];
    this.particiantJsonListAutoFillContact = [];

    let coretFolder: any = [];
    let contactFolder: any = [];

    this.fieldFolders = [];
    var objcore = {
      folderID: 17,
      name: "Core"
    }
    var objcontact = {
      folderID: 20,
      name: "Contact"
    }
    this.fieldFolders.push(objcore);
    this.fieldFolders.push(objcontact);

    coretFolder.push(this.fieldFolders.find(n => n.name == 'Core'));
    contactFolder.push(this.fieldFolders.find(n => n.name == 'Contact'));

    // For Core //
    if (this.type == 1) {
      if (this.controlAlignArray.length > 0) {
        let currentJsonArray: any = [];
        for (var i = 0, len = this.controlAlignArray.length; i < len; ++i) {
          var checkdataAutofillfields = [];
          checkdataAutofillfields = this.controlAlignArray[i].fields;
          if (checkdataAutofillfields.length > 0) {
            for (var i1 = 0, len1 = checkdataAutofillfields.length; i1 < len1; ++i1) {
              if (checkdataAutofillfields[i1].folderID == coretFolder[0].folderID) {
                var obj = {
                  fields: [checkdataAutofillfields[i1]],
                  pageName: this.controlAlignArray[i].pageName,
                  step: this.controlAlignArray[i].step,
                }
                currentJsonArray.push(obj);
              }
            }
          }
        }

        if (currentJsonArray.length > 0) {
          currentJsonArray.forEach(vb => {
            this.particiantJsonListAutoFillCore.push(vb)
          });
        }
      }
    }

    // For Contact //
    if (this.type == 2) {
      if (this.controlAlignArray.length > 0) {
        let currentJsonArray: any = [];
        for (var i = 0, len = this.controlAlignArray.length; i < len; ++i) {
          var checkdataAutofillfields = [];
          checkdataAutofillfields = this.controlAlignArray[i].fields;
          if (checkdataAutofillfields.length > 0) {
            for (var i1 = 0, len1 = checkdataAutofillfields.length; i1 < len1; ++i1) {
              if (checkdataAutofillfields[i1].folderID == contactFolder[0].folderID) {
                var obj = {
                  fields: [checkdataAutofillfields[i1]],
                  pageName: this.controlAlignArray[i].pageName,
                  step: this.controlAlignArray[i].step,
                }
                currentJsonArray.push(obj);
              }
            }
          }
        }

        if (currentJsonArray.length > 0) {
          currentJsonArray.forEach(vb => {
            this.particiantJsonListAutoFillContact.push(vb)
          });
        }
      }
    }

    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });

  }




  searchCity(name: any) {
    var ReqModel = {
      databaseID: Number(this.databaseId),
      Name: name,
      userID: this.userID
    }
    this.formsService.searchTransCities(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.cityOption = [];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }

  getStateDropdownList(countryId: any) {
    if (countryId != undefined) {
      this.formsService.getStateList(countryId).subscribe(response => {
        if (response != undefined) {
          if (response.status == this.statusConst.statusSuccess) {
            this.stateList = [];
            if (countryId == 231 || countryId == 38) {
              response.data = response.data.filter((x) => x.abbreviation != null);
              response.data.forEach(e => {
                this.stateList.push(e.abbreviation);
              });
            } else {
              response.data.forEach(e => {
                this.stateList.push(e.stateName);
              });
            }
          }
        }
      });
    }
  }


  searchZip(zip: any) {
    var ReqModel = {
      databaseID: Number(this.databaseId),
      ZipCodeValue: zip,
      userID: this.userID
    }
    this.formsService.searchTransZip(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.zipOption = [];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  zipselected(event: MatAutocompleteSelectedEvent, data: any, id) {

  }

  cityselected(event: MatAutocompleteSelectedEvent, data: any, id) {

  }

  hasSignature: boolean = false;
  hasInitials: boolean = false;
  dialogueRef: any;
  fiveSignaturesLimitReached = false;
  particiantJsonList: any = [];

  getAllInitials: any = [] = [];
  signatureID: number = 0;
  signatureData: any;
  initialData: any;
  InitialsID: number = 0;
  getAllSignatures: any = [] = [];
  fiveInitialsLimitReached: boolean = true;
  showInitials: boolean = true;


  getAllSignature(templateRef: TemplateRef<any>, datas, item) {   
    var rqModel = {
      email: this.participantEmailId,
    }
    this.formsService.getSignaturesAndInitials(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.getAllSignatures = this.responseHolder.data.signatures;

          if (this.getAllSignatures == null) {
            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
            });
            return;
          }

          if (this.getAllSignatures.length > 0) {
            this.hasSignature = true;
            this.getAllSignatures.forEach(n => {
              n.signature = JSON.parse(n.signature);
            });
          } else {
            this.hasSignature = false;
          }


          if (this.getAllSignatures.length == 5) {
            this.fiveSignaturesLimitReached = true;
          }
          else {
            this.fiveSignaturesLimitReached = false;
          }


          if (item.fieldJson.signatureBase64 != '' || item.fieldJson.ImageData.length != 0 || item.fieldJson.signatureText != '') {
            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
            });
            return;
          }

          var checkSignDefault = [];
          checkSignDefault = this.responseHolder.data.signatures.filter((x:any) => x.isDefault == true);
          if (checkSignDefault.length > 0) {

            let data: any = datas;//this.ControlData;
            // this.signatureID = this.signatureID;
            let sJson = checkSignDefault[0].signature;

            if (sJson.type == 'Draw') {
              this.signatureBase64 = sJson.signatureBase64;
              this.signName = "";
              this.signInitialFontFamily = "";
              this.signOrInitialImageObj = [];
            }
            if (sJson.type == 'Upload') {
              this.signatureBase64 = "";
              this.signName = "";
              this.signInitialFontFamily = "";
              this.signOrInitialImageObj = sJson.ImageData;
            }
            if (sJson.type == 'Type In') {
              this.signatureBase64 = "";
              this.signName = sJson.signatureText;
              this.signInitialFontFamily = sJson.signInitialFontFamily;
              this.signOrInitialImageObj = [];
            }
            // return;

            if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureBase64 = this.signatureBase64;
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureText = this.signName;
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signInitialFontFamily = this.signInitialFontFamily;
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.ImageData = this.signOrInitialImageObj;
            }

            if (this.dataJson.find(x => x.id == this.ControlId)) {
              if (this.signatureBase64 != '') {
                this.dataJson.find(x => x.id == this.ControlId).value = this.signatureBase64;
                this.dataJson.find(x => x.id == this.ControlId).type = 'image';
              }
              else if (this.signName != '') {
                this.dataJson.find(x => x.id == this.ControlId).value = this.signName;
                this.dataJson.find(x => x.id == this.ControlId).type = 'text';
                this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
              }
              else {
                this.dataJson.find(x => x.id == this.ControlId).value = this.signOrInitialImageObj[0].Imageurl;
                this.dataJson.find(x => x.id == this.ControlId).type = 'image';
                this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = '';
              }
            }
          } else {
            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
            });
          }
        } else {
          this.dialogueRef = this.dialog.open(templateRef, {
            panelClass: 'custom-modalboxSign'
          });
          return;
        }
      } else {
        this.dialogueRef = this.dialog.open(templateRef, {
          panelClass: 'custom-modalboxSign'
        });
        return;
      }
    });
  }

  deleteSignature(signature) {
    const message = `Are you sure you want to delete this signature?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            signatureID: signature.signatureID,
            email: this.participantEmailId
          }
          this.formsService.removeSignature(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.getAllSignatureInitialsAfterDelete();
              } else {

              }
            } else {

            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  selectedSignature(img: any) {
    this.signatureID = img.signatureID;
    this.signatureData = img;
    this.getAllSignatures.forEach(x => {
      x.isDefault = (x.signatureID == this.signatureID) ? true : false;
    })
    this.SignButtonEnable = true;
  }

  signatureType(type: string) {
    this.signOpt = type;
  }

  addNewSignature() {
    this.signatureID = 0;
    this.hasSignature = !this.hasSignature;
  }

  addDefaultSignature() {
    if (this.signatureID > 0) {
      this.addSignatureAdopt();
    }
    var rqModel = {
      signatureID: this.signatureID,
      email: this.participantEmailId,
      isDefault: true
    }
    this.formsService.addDefaultSignature(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {

        }
      }
    });
    this.dialogueRef.close();
  }

  addSignatureAdopt() {

    this.getAllSignatures.forEach(x => {
      x.isDefault = (x.signatureID == this.signatureID) ? true : false;
    })
    this.SignButtonEnable = true;

    let data: any = this.ControlData;
    this.signatureID = this.signatureID;
    let sJson = this.signatureData.signature;

    if (sJson.type == 'Draw') {
      this.signatureBase64 = sJson.signatureBase64;
      this.signName = "";
      this.signInitialFontFamily = "";
      this.signOrInitialImageObj = [];
    }
    if (sJson.type == 'Upload') {
      this.signatureBase64 = "";
      this.signName = "";
      this.signInitialFontFamily = "";
      this.signOrInitialImageObj = sJson.ImageData;
    }
    if (sJson.type == 'Type In') {
      this.signatureBase64 = "";
      this.signName = sJson.signatureText;
      this.signInitialFontFamily = sJson.signInitialFontFamily;
      this.signOrInitialImageObj = [];
    }   

    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureBase64 = this.signatureBase64;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureText = this.signName;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signInitialFontFamily = this.signInitialFontFamily;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.ImageData = this.signOrInitialImageObj;
    }

    if (this.dataJson.find(x => x.id == this.ControlId)) {
      if (this.signatureBase64 != '') {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signatureBase64;
        this.dataJson.find(x => x.id == this.ControlId).type = 'image';
      }
      else if (this.signName != '') {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signName;
        this.dataJson.find(x => x.id == this.ControlId).type = 'text';
        this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      }
      else {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signOrInitialImageObj[0].Imageurl;
        this.dataJson.find(x => x.id == this.ControlId).type = 'image';
        this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = '';
      }
    }

  }

  getAllSignatureInitialsAfterDelete() {
    var rqModel = {
      email: this.participantEmailId,
    }
    this.formsService.getSignaturesAndInitials(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.getAllSignatures = this.responseHolder.data.signatures;
          this.getAllInitials = this.responseHolder.data.initials;

          if (this.getAllSignatures.length > 0) {
            this.hasSignature = true;
            this.getAllSignatures.forEach(n => {
              n.signature = JSON.parse(n.signature);
            });
          } else {
            this.hasSignature = false;
          }

          if (this.getAllInitials.length > 0) {
            this.getAllInitials.forEach(n => {
              n.initial = JSON.parse(n.initial);
            });
          } else {
            this.hasInitials = false;
          }

          if (this.getAllSignatures.length == 5) {
            this.fiveSignaturesLimitReached = true;
          }
          else {
            this.fiveSignaturesLimitReached = false;
          }

          if (this.getAllInitials.length == 5) {
            this.fiveInitialsLimitReached = true;
          }
          else {
            this.fiveInitialsLimitReached = false;
          }
        }
      }
    });
  }

  getAllInitial(templateRef: TemplateRef<any>, datas, item) {
    var rqModel = {
      email: this.participantEmailId,
    }

    this.formsService.getSignaturesAndInitials(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.getAllInitials = this.responseHolder.data.initials;
          if (this.getAllInitials == null) {
            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
            });
            return;
          }

          if (this.getAllInitials.length > 0) {
            this.hasInitials = true;
            this.getAllInitials.forEach(n => {
              n.initial = JSON.parse(n.initial);
            });
          } else {
            this.hasInitials = false;
          }

          if (this.getAllInitials.length == 5) {
            this.fiveInitialsLimitReached = true;
          }
          else {
            this.fiveInitialsLimitReached = false;
          }

          if (item.fieldJson.signatureBase64 != '' || item.fieldJson.ImageData.length != 0 || item.fieldJson.signatureText != '') {
            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
            });
            return;
          }

          var checkInitialsDefault = [];
          checkInitialsDefault = this.responseHolder.data.initials.filter((x:any) => x.isDefault == true);
          if (checkInitialsDefault.length > 0) {

            let data: any = datas;//this.ControlData;
            // this.signatureID = this.signatureID;
            let iJson = checkInitialsDefault[0].initial;

            if (iJson.type == 'Draw') {
              this.signatureBase64 = iJson.signatureBase64;
              this.signName = "";
              this.signInitialFontFamily = "";
              this.signOrInitialImageObj = [];
            }
            if (iJson.type == 'Upload') {
              this.signatureBase64 = "";
              this.signName = "";
              this.signInitialFontFamily = "";
              this.signOrInitialImageObj = iJson.ImageData;
            }
            if (iJson.type == 'Type In') {
              this.signatureBase64 = "";
              this.signName = iJson.signatureText;
              this.signInitialFontFamily = iJson.signInitialFontFamily;
              this.signOrInitialImageObj = [];
            }
            // return;

            if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureBase64 = this.signatureBase64;
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureText = this.signName;
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signInitialFontFamily = this.signInitialFontFamily;
              this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.ImageData = this.signOrInitialImageObj;
            }
            if (this.dataJson.find(x => x.id == this.ControlId)) {
              if (this.signatureBase64 != '') {
                this.dataJson.find(x => x.id == this.ControlId).value = this.signatureBase64;
                this.dataJson.find(x => x.id == this.ControlId).type = 'image';
              }
              else if (this.signName != '') {
                this.dataJson.find(x => x.id == this.ControlId).value = this.signName;
                this.dataJson.find(x => x.id == this.ControlId).type = 'text';
                this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
              }
              else {
                this.dataJson.find(x => x.id == this.ControlId).value = this.signOrInitialImageObj[0].Imageurl;
                this.dataJson.find(x => x.id == this.ControlId).type = 'image';
                this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = '';
              }
            }
          } else {
            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
            });
          }
        } else {
          this.dialogueRef = this.dialog.open(templateRef, {
            panelClass: 'custom-modalboxSign'
          });
          return;
        }
      } else {
        this.dialogueRef = this.dialog.open(templateRef, {
          panelClass: 'custom-modalboxSign'
        });
        return;
      }
    });
  }


  addInitails() {
    if (this.InitialsID > 0) {
      this.addInitialdopt();
    } else {
      let data: any = this.ControlData;
      let canvas = document.getElementsByTagName("canvas")[0];
      if (canvas != undefined) {
        this.signatureBase64 = canvas.toDataURL();
        this.signName = "";
        this.signOrInitialImageObj = [];
      }     

      if(this.controlAlignArray.find(x => x.step == this.currentStep)) {
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureBase64 = this.signatureBase64;
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureText = this.signName;
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signInitialFontFamily = this.signInitialFontFamily;
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.ImageData = this.signOrInitialImageObj;

        if (this.dataJson.find(x => x.id == this.ControlId)) {
          if (this.signatureBase64 != '') {
            this.dataJson.find(x => x.id == this.ControlId).value = this.signatureBase64;
            this.dataJson.find(x => x.id == this.ControlId).type = 'image';
          }
          else if (this.signName != '') {
            this.dataJson.find(x => x.id == this.ControlId).value = this.signName;
            this.dataJson.find(x => x.id == this.ControlId).type = 'text';
            this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
          }
          else {
            this.dataJson.find(x => x.id == this.ControlId).value = this.signOrInitialImageObj[0].Imageurl;
            this.dataJson.find(x => x.id == this.ControlId).type = 'image';
            this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = '';
          }
        }

        var obj;
        if (this.signatureBase64 != "") {
          obj = {
            type: "Draw",
            signatureBase64: this.signatureBase64,
          }
        }
        if (this.signOrInitialImageObj.length > 0) {
          obj = {
            type: "Upload",
            ImageData: this.signOrInitialImageObj,
          }
        }
        if (this.signName != "") {
          obj = {
            type: "Type In",
            signatureText: this.signName,
            signInitialFontFamily: this.signInitialFontFamily
          }
        }       
        var rqModel = {
          initial: JSON.stringify(obj),
          email: this.participantEmailId,
          isDefault: true
        }
        this.formsService.addInitial(rqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {

            }
          }
        });
      }
    }
    this.dialogueRef.close();
  }

  addInitialdopt() {
    this.getAllInitials.forEach(x => {
      x.isDefault = (x.initialID == this.InitialsID) ? true : false;
    })
    this.InitailButtonEnable = true;

    let data: any = this.ControlData;
    this.InitialsID = this.InitialsID;
    let iJson = this.initialData.initial;

    if (iJson.type == 'Draw') {
      this.signatureBase64 = iJson.signatureBase64;
      this.signName = "";
      this.signInitialFontFamily = "";
      this.signOrInitialImageObj = [];
    }
    if (iJson.type == 'Upload') {
      this.signatureBase64 = "";
      this.signName = "";
      this.signInitialFontFamily = "";
      this.signOrInitialImageObj = iJson.ImageData;
    }
    if (iJson.type == 'Type In') {
      this.signatureBase64 = "";
      this.signName = iJson.signatureText;
      this.signInitialFontFamily = iJson.signInitialFontFamily;
      this.signOrInitialImageObj = [];
    }
    // return;

    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureBase64 = this.signatureBase64;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureText = this.signName;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signInitialFontFamily = this.signInitialFontFamily;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.ImageData = this.signOrInitialImageObj;
    }

    if (this.dataJson.find(x => x.id == this.ControlId)) {
      if (this.signatureBase64 != '') {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signatureBase64;
        this.dataJson.find(x => x.id == this.ControlId).type = 'image';
      }
      else if (this.signName != '') {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signName;
        this.dataJson.find(x => x.id == this.ControlId).type = 'text';
        this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      }
      else {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signOrInitialImageObj[0].Imageurl;
        this.dataJson.find(x => x.id == this.ControlId).type = 'image';
        this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = '';
      }
    };

  }

  addDefaultInitials() {
    if (this.InitialsID > 0) {
      this.addInitialdopt();
    }
    var rqModel = {
      initialID: this.InitialsID,
      email: this.participantEmailId,
      isDefault: true
    }
    this.formsService.changeDefaultInitial(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
        }
      }
    });
    this.dialogueRef.close();
  }

  clearInitail() {
    this.InitailButtonEnable = false;
    if (this.signaturePad != undefined) {
      this.signaturePad.clear();
    }
    let canvas = document.getElementsByTagName("canvas")[0];
    if (canvas != undefined) {
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.beginPath();
    }
  }


  deleteInitails(initial) {
    const message = `Are you sure you want to delete this initial?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            initialID: initial.initialID,
            email: this.participantEmailId
          }
          this.formsService.removeInitial(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.getAllSignatureInitialsAfterDelete();
              } else {
              }
            } else {
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  addNewInitial() {
    this.InitialsID = 0;
    this.hasInitials = !this.hasInitials;
  }

  selectedInitials(img: any) {
    this.InitialsID = img.initialID;
    this.initialData = img;
    this.getAllInitials.forEach(x => {
      x.isDefault = (x.initialID == this.InitialsID) ? true : false;
    })
    this.InitailButtonEnable = true;
  }

  getClass(className: any) {
    return `${className.IsFullWidth} ${className.alignBlock}`
  }

  authenticationMobile: string=""; 
  showEmail:boolean=true;
  showMobile:boolean=false;
       
    
}



